module.exports = __webpack_public_path__ + "static/media/logo.685b54d8.PNG";